import { Component, OnInit } from '@angular/core';
import { Base } from '../base/base';

@Component({
  selector: 'login-failed',
  templateUrl: './failed.component.html'
})
export class FailedComponent extends Base implements OnInit {
  loading: boolean = true;
  constructor() {
      super();
  }

  ngOnInit(): void {

  }

}
